import React, { useEffect, useState } from "react";
import { backend_url } from "../App";
import PrintDesignForm from "../Components/PrintDesignForm/PrintDesignForm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./CSS/FabricDatabase.css"; // shared card-grid styling (fabric-* classes)

const STATUS_CLASS = {
  "Design": "fabric-stock-low",
  "Sample": "fabric-stock-low",
  "Approved": "fabric-stock-in",
  "In Production": "fabric-stock-in",
  "Completed": "fabric-stock-in",
};

const CustomPrinting = () => {
  const [designs, setDesigns] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchDesigns(); }, []);

  const fetchDesigns = async (query = "") => {
    setLoading(true);
    try {
      const res = await fetch(`${backend_url}/api/print-designs${query ? `?search=${encodeURIComponent(query)}` : ""}`);
      const data = await res.json();
      setDesigns(data.success ? data.designs : []);
    } catch {
      setDesigns([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    fetchDesigns(e.target.value);
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Remove this print design?")) return;
    try {
      const res = await fetch(`${backend_url}/api/print-designs/${id}`, { method: "DELETE" });
      const data = await res.json();
      if (!data.success) throw new Error();
      toast.success("Design removed");
      setDesigns((prev) => prev.filter((d) => d._id !== id));
    } catch {
      toast.error("Failed to remove design");
    }
  };

  return (
    <div className="fabric-page">
      <div className="fabric-header">
        <div className="fabric-title-group">
          <h2 className="fabric-title">🎨 Custom Fabric Printing</h2>
          <span className="fabric-count-badge">{designs.length} designs</span>
        </div>
        <div className="fabric-search-wrap">
          <span className="fabric-search-icon">🔍</span>
          <input type="text" placeholder="Search by collection or pattern..." value={search} onChange={handleSearch} />
        </div>
        <button className="fabric-add-btn" onClick={() => setSelectedId(null)}>+ Add Design</button>
      </div>

      {loading ? (
        <p className="fabric-empty-msg">Loading…</p>
      ) : designs.length === 0 ? (
        <div className="fabric-empty-msg">
          <div className="fabric-empty-icon">🎨</div>
          No print designs yet — click "Add Design" to register your first one.
        </div>
      ) : (
        <div className="fabric-grid">
          {designs.map((d) => (
            <div key={d._id} className="fabric-card" onClick={() => setSelectedId(d._id)}>
              <div className="fabric-card-img-wrap">
                {d.referenceImages?.[0] ? (
                  <img src={d.referenceImages[0]} alt={d.floralCollection} className="fabric-card-img" />
                ) : (
                  <div className="fabric-card-img-placeholder">No Image</div>
                )}
                <span className={`fabric-stock-badge ${STATUS_CLASS[d.productionStatus] || "fabric-stock-low"}`}>{d.productionStatus}</span>
                <button className="fabric-del-btn" onClick={(e) => handleDelete(d._id, e)} title="Remove">✕</button>
              </div>
              <div className="fabric-card-body">
                <div className="fabric-card-top">
                  <span className="fabric-card-id">{d.printDesignId}</span>
                  <span className="fabric-card-cost">{d.sampleApproved ? "✅ Sample OK" : "Sample pending"}</span>
                </div>
                <h4 className="fabric-card-type">{d.floralCollection || d.surfacePatternDesign || "Untitled Design"}</h4>
                <div className="fabric-card-meta">
                  {(d.colourVariations || []).slice(0, 3).map((c) => <span key={c}>{c}</span>)}
                </div>
                {d.moq && <span className="fabric-print-pill">MOQ {d.moq}</span>}
              </div>
            </div>
          ))}
        </div>
      )}

      {selectedId !== undefined && (
        <PrintDesignForm designId={selectedId} onClose={() => setSelectedId(undefined)} onSaved={() => fetchDesigns(search)} />
      )}
      <ToastContainer position="top-right" autoClose={2500} />
    </div>
  );
};

export default CustomPrinting;
